export const SET_PAGE_INDEX_REPORT = '@siteReports/SET_PAGE_INDEX_REPORT';
export const SET_REPORTS = '@siteReports/SET_REPORTS';
export const SET_FILTERED_REPORTS = '@siteReports/SET_FILTERED_REPORTS';
export const SET_IS_LOADING = '@siteReports/SET_IS_LOADING';
export const SET_IS_FETCHING = '@siteReports/SET_IS_FETCHING';
export const SET_SORT_DIRECTION = '@siteReports/SET_SORT_DIRECTION';
export const SET_COLOR_CHANGE = '@siteReports/SET_COLOR_CHANGE';
export const SET_REPORT_USER_FILTERS = '@siteReports/SET_REPORT_USER_FILTERS';
export const SET_REPORT_QUESTIONNAIRE_FILTERS = '@siteReports/SET_REPORT_QUESTIONNAIRE_FILTERS';
export const SET_FILTER_QUERY = '@siteReports/SET_FILTER_QUERY';
export const SET_BACK_TEMPORARY_REPORT = '@siteReports/SET_BACK_TEMPORARY_REPORT';
export const SET_PERIOD_TYPE = '@siteReports/SET_PERIOD_TYPE';
export const SET_CUSTOM_DATES = '@siteReports/SET_CUSTOM_DATES';
export const SET_DATES = '@siteReports/SET_DATES';
export const SET_PREVIOUS_DATES = '@siteReports/SET_PREVIOUS_DATES';
export const RESET_SITE_REPORT_FILTER_DATES = '@siteReports/RESET_SITE_REPORT_FILTER_DATES';
export const RESET_SITE_REPORT_FILTER = '@siteReports/RESET_SITE_REPORT_FILTER';
export const APPLY_SITE_REPORT_FILTER = '@siteReports/APPLY_SITE_REPORT_FILTER';
export const SET_FILTERED_START_DATE_TEMP = '@siteReports/SET_FILTERED_START_DATE_TEMP';
export const SET_FILTERED_END_DATE_TEMP = '@siteReports/SET_FILTERED_END_DATE_TEMP';
export const SET_FILTERED_DATES_TEMP = '@siteReports/SET_FILTERED_DATES_TEMP';
export const SET_FILTERED_SORT_DIRECTION_TEMP = '@siteReports/SET_FILTERED_SORT_DIRECTION_TEMP';

export const FETCH_SITE_REPORTS_REQUEST = '@siteReports/FETCH_SITE_REPORTS_REQUEST';
export const FETCH_SITE_REPORTS_SUCCESS = '@siteReports/FETCH_SITE_REPORTS_SUCCESS';
export const FETCH_SITE_REPORTS_FAILURE = '@siteReports/FETCH_SITE_REPORTS_FAILURE';

// Lite report actions (new aggregated flow)
export const FETCH_LITE_REPORTS_REQUEST = '@siteReports/FETCH_LITE_REPORTS_REQUEST';
export const FETCH_LITE_REPORTS_SUCCESS = '@siteReports/FETCH_LITE_REPORTS_SUCCESS';
export const FETCH_LITE_REPORTS_FAILURE = '@siteReports/FETCH_LITE_REPORTS_FAILURE';
export const FETCH_LITE_GROUPED_REPORTS_REQUEST = '@siteReports/FETCH_LITE_GROUPED_REPORTS_REQUEST';
export const FETCH_LITE_GROUPED_REPORTS_SUCCESS = '@siteReports/FETCH_LITE_GROUPED_REPORTS_SUCCESS';
export const FETCH_LITE_GROUPED_REPORTS_FAILURE = '@siteReports/FETCH_LITE_GROUPED_REPORTS_FAILURE';
export const SET_LITE_REPORTS_GROUP_BY = '@siteReports/SET_LITE_REPORTS_GROUP_BY';
export const SET_LITE_REPORTS_DATE_RANGE = '@siteReports/SET_LITE_REPORTS_DATE_RANGE';
export const SET_LITE_REPORTS_FILTER_QUERY = '@siteReports/SET_LITE_REPORTS_FILTER_QUERY';
export const SET_LITE_REPORTS_PAGE = '@siteReports/SET_LITE_REPORTS_PAGE';
export const SET_LITE_REPORTS_FILTERS = '@siteReports/SET_LITE_REPORTS_FILTERS';
export const RESET_LITE_REPORTS = '@siteReports/RESET_LITE_REPORTS';
